module.exports = __webpack_public_path__ + "img/P3.1ad5bf54.gif";